import {useEffect} from 'react';
import i18n from "i18next";

export default function PeopleTableHead({state, dispatch}) {
    useEffect(() => {
        if(state.sortingToggle % 2 === 1) {
            dispatch({ type: "sortDirectionAsc" });
        } else {
            dispatch({ type: "sortDirectionDesc" });
        }
    }, [state.sortingToggle, state.columnSort])

    const headerLabels = [
        {
            name: 'name',
            label: i18n.t('manage.users.name'),
        },
        {
            name: 'phone',
            label: i18n.t('manage.users.phone'),
        },
        {
            name: 'email',
            label: i18n.t('manage.users.email'),
        },
        {
            name: 'status',
            label: i18n.t('manage.users.status'),
        },
        {
            name: 'created_at',
            label: i18n.t('manage.users.added-on'),
        },
    ];

    return (
        <thead>
            <tr>
                {headerLabels.map((data, key) => {
                    return <th className={`sorting-headers ${data.name}-header`} id={data.name} key={key} scope="col" onClick={() => {
                        dispatch({ type: "sortingToggle", payload: { sortingToggle: data.name }});
                        dispatch({ type: "columnSort", payload: { columnSort: data.name }});
                    }}>{data.label}
                        {state.columnSort === data.label ? state.sortDirection === 'asc' ?
                        <i className="far fa-chevron-down" /> :
                        <i className="far fa-chevron-up" /> : null}</th>
                })}

                <th className="table-fit" scope="col"></th>
            </tr>
        </thead>
    )
}
